var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteProductRelatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#DB4D29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8266 14.7204H22.5599L20.3066 12.467C20.1266 12.287 19.8333 12.287 19.6466 12.467C19.4666 12.647 19.4666 12.9404 19.6466 13.127L21.2399 14.7204H14.7599L16.3533 13.127C16.5333 12.947 16.5333 12.6537 16.3533 12.467C16.1733 12.287 15.8799 12.287 15.6933 12.467L13.4466 14.7204H13.1799C12.5799 14.7204 11.3333 14.7204 11.3333 16.427C11.3333 17.0737 11.4666 17.5004 11.7466 17.7804C11.9066 17.947 12.0999 18.0337 12.3066 18.0804C12.4999 18.127 12.7066 18.1337 12.9066 18.1337H23.0933C23.2999 18.1337 23.4933 18.1204 23.6799 18.0804C24.2399 17.947 24.6666 17.547 24.6666 16.427C24.6666 14.7204 23.4199 14.7204 22.8266 14.7204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6999 19H13.2466C12.8333 19 12.5199 19.3667 12.5866 19.7733L13.1466 23.2C13.3333 24.3467 13.8333 25.6667 16.0533 25.6667H19.7933C22.0399 25.6667 22.4399 24.54 22.6799 23.28L23.3533 19.7933C23.4333 19.38 23.1199 19 22.6999 19ZM17.0733 23.3C17.0733 23.56 16.8666 23.7667 16.6133 23.7667C16.3533 23.7667 16.1466 23.56 16.1466 23.3V21.1C16.1466 20.8467 16.3533 20.6333 16.6133 20.6333C16.8666 20.6333 17.0733 20.8467 17.0733 21.1V23.3ZM19.9266 23.3C19.9266 23.56 19.7199 23.7667 19.4599 23.7667C19.2066 23.7667 18.9933 23.56 18.9933 23.3V21.1C18.9933 20.8467 19.2066 20.6333 19.4599 20.6333C19.7199 20.6333 19.9266 20.8467 19.9266 21.1V23.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteProductRelatedIcon);
export default __webpack_public_path__ + "static/media/delete-product-related-icon.87aa7cb7b64f57d9ff6e75e74de5f866.svg";
export { ForwardRef as ReactComponent };